import { Modal } from "react-bootstrap";
import { GeoAltFill } from "react-bootstrap-icons";
import { Link } from "react-router-dom";
import { Button } from "./Controls/Button";

export default function SubscriptionIntroModal({
  show,
  setShow,
  inviteData,
  showMoney,
  cents,
}) {
  return (
    <Modal centered show={show} onHide={() => setShow(false)}>
      <Modal.Body className="px-4 py-4">
        <p className="fs-5 mb-4">
          To continue with your parking subscription at{" "}
          <b>{inviteData?.facility.name}</b>, please sign in or create an
          account.
        </p>

        <hr className="my-4" />

        <div className="fs-5 fw-bold">
          Monthly Rate: {showMoney(cents(inviteData.price))}
        </div>

        <div className="mb-4 d-flex flex-column gap-2">
          <div className="text-secondary d-flex gap-2 align-items-start">
            <GeoAltFill
              className="flex-shrink-0"
              style={{
                fontSize: "1.2rem",
                marginTop: "0.2rem",
                color: "#6c757d",
              }}
            />
            <div>
              {inviteData.facility.address.addressLine1}
              {inviteData.facility.address.addressLine2 && (
                <>, {inviteData.facility.address.addressLine2}</>
              )}
              <br />
              {inviteData.facility.address.city},{" "}
              {inviteData.facility.address.state}{" "}
              {inviteData.facility.address.zipCode}
            </div>
          </div>
        </div>

        <div className="d-flex flex-column gap-3">
          <div className="border rounded p-3 bg-white">
            <div className="d-flex align-items-start">
              <div className="me-3 mt-1">
                <div
                  className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
                  style={{
                    width: "32px",
                    height: "32px",
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                >
                  1
                </div>
              </div>
              <div>
                <h6 className="mb-1 fw-bold">New User?</h6>
                <p className="mb-0 text-muted small">
                  <Link to="/signup">Sign up</Link> to create your account in
                  seconds
                </p>
              </div>
            </div>
          </div>

          <div className="border rounded p-3 bg-white">
            <div className="d-flex align-items-start">
              <div className="me-3 mt-1">
                <div
                  className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
                  style={{
                    width: "32px",
                    height: "32px",
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                >
                  2
                </div>
              </div>
              <div>
                <h6 className="mb-1 fw-bold">Already Registered?</h6>
                <p className="mb-0 text-muted small">
                  Enter your credentials to continue
                </p>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button className="btn-main" onClick={() => setShow(false)}>
          Continue
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
